import { useTranslations } from 'next-intl';

export const FooterAddress = ({ address }: { address: string }) => {
    const t = useTranslations();

    if (!address) {
        return null;
    }

    return (
        <div className='flex max-w-full flex-col items-center justify-center gap-1 px-4 pt-4 lg:max-w-[200px] lg:items-start lg:gap-1 lg:p-4 [&_svg]:shrink-0'>
            <p className='align-bottom text-[16px] font-[800] leading-[100%] tracking-normal'>{t('address')}</p>
            <p className='text-center align-bottom text-[12px] font-[500] leading-[18px] tracking-normal lg:text-left'>
                <span dangerouslySetInnerHTML={{ __html: address }} />
            </p>
        </div>
    );
};
